import { ArmyListUnit } from '@Models';
import { EntityId, EntityIdParams } from '@Models';

export class ArmyListUnitView extends EntityId<string> {
  points: number;
  showV1: boolean;
  showV2: boolean;
  showV3: boolean;
  item: ArmyListUnit | null;

  constructor(params: ArmyListUnitViewParams) {
    super(params);
    this.points = params.points;
    this.showV1 = params.showV1;
    this.showV2 = params.showV2;
    this.showV3 = params.showV3;
    this.item = params.item ?? null;
  }
}

type ArmyListUnitViewParams = EntityIdParams<string> & {
  points: number;
  showV1: boolean;
  showV2: boolean;
  showV3: boolean;
  item: ArmyListUnit | null;
};
